import { useSearchParams } from "@remix-run/react";
import isNil from "~/kernel/validation/isNil";

export default function useSearchParam(key: string, defaultValue?: string) {
  const [searchParams, setSearchParams] = useSearchParams();

  type NavigateOptions = Parameters<typeof setSearchParams>[1];

  return [
    searchParams.get(key) ?? defaultValue ?? null,
    (value: string | null, options?: NavigateOptions) => {
      const newParams = new URLSearchParams(searchParams);

      if (isNil(value)) {
        newParams.delete(key);
      } else {
        newParams.set(key, value);
      }

      return setSearchParams(newParams, options);
    },
  ] as const;
}
